import { FaqRepository } from './repository'

export default {
  async LOAD_FAQ({ commit }) {
    const faq = await FaqRepository.loadFaq()

    commit('SET_FAQ', faq)
  }
}
